// extracted by mini-css-extract-plugin
export default {"wrapper":"qU-z","ratingContainer":"rU-z","ratingValue":"sU-z","starSprite":"tU-z","ratingLabel":"uU-z","error":"vU-z","errorBox":"wU-z"};